import { Tooltip, Button, Tag } from "@chakra-ui/react";

export const UserRoleEnum = {
  ADMIN: 1,
  USER: 2,
  // SuperAdmin:3,
};

export const userRoles = [
  { value: UserRoleEnum.ADMIN, label: "Admin" },
  { value: UserRoleEnum.USER, label: "User" },
  // {value: UserRoleEnum.SuperAdmin, label: 'SuperAdmin'}
];



export const renderLicenseIcon = (licenceTypeName: string) => {
  switch (licenceTypeName) {
    case "Basic":
      return (
        <Tooltip label="Basic License" placement="top">
          <Button size="sm" colorScheme="blue" mr={2}>
            <i className="bi bi-file-earmark-text"></i>
          </Button>
        </Tooltip>
      );
    case "Pro":
      return (
        <Tooltip label="Pro License" placement="top">
          <Button size="sm" colorScheme="green" mr={2}>
            <i className="bi bi-star"></i>
          </Button>
        </Tooltip>
      );
    case "Enterprise":
      return (
        <Tooltip label="Enterprise License" placement="top">
          <Button size="sm" colorScheme="purple">
            <i className="bi bi-building"></i>
          </Button>
        </Tooltip>
      );
    default:
      return (
        <Tag colorScheme="gray" size="lg">
          <i className="bi bi-slash-circle" style={{ marginRight: 6 }} />
          License not assigned
        </Tag>
      );
  }
};

// 1) color lookup
export const getLicenseColor = (LicenceTypeName: string ) => {
  switch (LicenceTypeName) {
    case "Basic": // e.g. 101
      return "blue";
    case "Pro": // e.g. 102
      return "green";
    case "Enterprise": // e.g. 103
      return "purple";
    default:
      return "gray";
  }
};

// 2) human‐readable name
// export const getLicenseName = (licenseType: LicenseType): string => {
//   switch (licenseType) {
//     case LicenseType.Basic:
//       return "Basic";
//     case LicenseType.Pro:
//       return "Pro";
//     case LicenseType.Enterprise:
//       return "Enterprise";
//     default:
//       return " License not assigned";
//   }
// };

export enum LicenseType {
  Basic = 101,
  Pro = 102,
  Enterprise = 103,
}

export const renderLicenseIconbyId = (licenseType: LicenseType) => {
  switch (licenseType) {
    case LicenseType.Basic:
      return (
        <Tooltip label="Basic License" placement="top">
          <Button size="sm" colorScheme="blue" mr={2}>
            <i className="bi bi-file-earmark-text"></i>
          </Button>
        </Tooltip>
      );
    case LicenseType.Pro:
      return (
        <Tooltip label="Pro License" placement="top">
          <Button size="sm" colorScheme="green" mr={2}>
            <i className="bi bi-star"></i>
          </Button>
        </Tooltip>
      );
    case LicenseType.Enterprise:
      return (
        <Tooltip label="Enterprise License" placement="top">
          <Button size="sm" colorScheme="purple">
            <i className="bi bi-building"></i>
          </Button>
        </Tooltip>
      );
    default:
      return (
        <Tag colorScheme="gray" size="lg">
          <i className="bi bi-slash-circle" style={{ marginRight: 6 }} />
          License not assigned
        </Tag>
      );
  }
};